export default __webpack_public_path__ + "static/media/Stack Array Visual.ce2f26e5.svg";